/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: flex;
  flex-direction: column;
  background-color: var(--calcite-color-foreground-1);
  --calcite-list-item-icon-color: var(--calcite-color-brand);
}

:host([filter-hidden]),
:host([closed]) {
  display: none;
}

.wrapper--bordered {
  border-block-end: 1px solid var(--calcite-color-border-3);
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

.container {
  box-sizing: border-box;
  display: flex;
  flex: 1 1 0%;
  overflow: hidden;
  background-color: var(--calcite-color-foreground-1);
}
.container * {
  box-sizing: border-box;
}

.container--hover:hover {
  cursor: pointer;
  background-color: var(--calcite-color-foreground-2);
}

.container:active {
  background-color: var(--calcite-color-foreground-1);
}

.container--border {
  border-inline-start-width: 4px;
  border-inline-start-style: solid;
}

.container--border-selected {
  border-inline-start-color: var(--calcite-color-brand);
}

.container--border-unselected {
  border-inline-start-color: transparent;
}

.container:hover.container--border-unselected {
  border-color: var(--calcite-color-border-1);
}

.nested-container {
  display: none;
  flex-direction: column;
  border-width: 0px;
  border-style: solid;
  border-color: var(--calcite-color-border-3);
  margin-inline-start: var(--calcite-list-item-spacing-indent, 1.5rem);
}

.nested-container--open {
  display: flex;
}

.content-container {
  display: flex;
  flex: 1 1 auto;
  -webkit-user-select: none;
          user-select: none;
  align-items: stretch;
  padding: 0px;
  font-weight: var(--calcite-font-weight-normal);
  color: var(--calcite-color-text-2);
}

.content-container--unavailable {
  opacity: var(--calcite-opacity-disabled);
}

tr,
td {
  outline-color: transparent;
}

tr {
  position: relative;
}

tr:focus,
td:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

.content,
.custom-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  padding-inline: 0.75rem;
  padding-block: 0.5rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
}

.label,
.description,
.content-bottom {
  font-family: var(--calcite-font-family);
  font-size: var(--calcite-font-size--2);
  font-weight: var(--calcite-font-weight-normal);
  word-wrap: break-word;
  word-break: break-word;
}
.label:only-child,
.description:only-child,
.content-bottom:only-child {
  margin: 0px;
  padding-block: 0.25rem;
}

.label {
  color: var(--calcite-color-text-1);
}

:host([selected]) .label {
  font-weight: var(--calcite-font-weight-medium);
}

.description {
  margin-block-start: 0.125rem;
  color: var(--calcite-color-text-3);
}

:host([selected]) .description {
  color: var(--calcite-color-text-2);
}

.content-start {
  justify-content: flex-start;
}

.content-end {
  justify-content: flex-end;
}

.content-start,
.content-end {
  flex: 1 1 auto;
}
.content-start ::slotted(calcite-icon),
.content-end ::slotted(calcite-icon) {
  margin-inline: 0.75rem;
  align-self: center;
}

.content-bottom {
  display: flex;
  flex-direction: column;
}

.content-container--has-center-content .content-start,
.content-container--has-center-content .content-end {
  flex: 0 1 auto;
}

.selection-container {
  display: flex;
  padding-block: 0px;
  color: var(--calcite-color-border-input);
  padding-inline: var(--calcite-spacing-md) var(--calcite-spacing-xxs);
}

.selection-container--single {
  color: transparent;
}

:host(:not([disabled]):not([selected])) .container:hover .selection-container--single {
  color: var(--calcite-color-border-1);
}

:host([selected]:hover) .selection-container,
:host([selected]:hover) .selection-container--single,
:host([selected]) .selection-container {
  color: var(--calcite-list-item-icon-color);
}

.open-container {
  color: var(--calcite-color-text-3);
}

:host(:not([disabled])) .container:hover .open-container {
  color: var(--calcite-color-text-1);
}

.actions-start,
.actions-end,
.content-start,
.content-end,
.selection-container,
.drag-container,
.open-container {
  display: flex;
  align-items: center;
}
.actions-start calcite-action,
.actions-start calcite-handle,
.actions-end calcite-action,
.actions-end calcite-handle,
.content-start calcite-action,
.content-start calcite-handle,
.content-end calcite-action,
.content-end calcite-handle,
.selection-container calcite-action,
.selection-container calcite-handle,
.drag-container calcite-action,
.drag-container calcite-handle,
.open-container calcite-action,
.open-container calcite-handle {
  align-self: stretch;
}

.open-container,
.selection-container {
  cursor: pointer;
}

.actions-start,
.actions-end {
  position: relative;
  padding: 0px;
}
.actions-start ::slotted(calcite-action),
.actions-start ::slotted(calcite-action-menu),
.actions-start ::slotted(calcite-handle),
.actions-start ::slotted(calcite-dropdown),
.actions-end ::slotted(calcite-action),
.actions-end ::slotted(calcite-action-menu),
.actions-end ::slotted(calcite-handle),
.actions-end ::slotted(calcite-dropdown) {
  align-self: stretch;
  color: inherit;
}

tr:focus .actions-start,
tr:focus .actions-end {
  inset-block: 0.125rem;
}
tr:focus .actions-start .close,
tr:focus .actions-start ::slotted(calcite-action),
tr:focus .actions-start ::slotted(calcite-action-menu),
tr:focus .actions-start ::slotted(calcite-handle),
tr:focus .actions-start ::slotted(calcite-dropdown),
tr:focus .actions-end .close,
tr:focus .actions-end ::slotted(calcite-action),
tr:focus .actions-end ::slotted(calcite-action-menu),
tr:focus .actions-end ::slotted(calcite-handle),
tr:focus .actions-end ::slotted(calcite-dropdown) {
  block-size: calc(100% - 0.25rem);
}
tr:focus::after, tr:focus::before {
  position: absolute;
  content: "";
  inline-size: 0.125rem;
  z-index: var(--calcite-z-index-header);
  background-color: var(--calcite-color-brand);
  inset-block: 0;
}
tr:focus::before {
  inset-inline-start: 0;
}
tr:focus::after {
  inset-inline-end: 0;
}

.container--border:focus::before {
  display: none;
}

::slotted(calcite-list:empty) {
  border-block-start-width: 0px;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}